import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/lettuce.png";
import sliced from "../../assets/images/ingredients/lettuceCut.png";

const Lettuce = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Lettuce"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Lettuce;